"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.cleanCustomerDataToFE = exports.cleanCustomerDataToBE = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _countries = require("./countries");

var _locale = require("./locale");

var _Logger = _interopRequireDefault(require("./Logger"));

var billingRequiredFields = {
  name: true,
  email: true,
  phone: true,
  address: true
};

var cleanCustomerDataToBE = function cleanCustomerDataToBE(data) {
  var requiredFields = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : billingRequiredFields;

  var _customerData = (0, _extends2["default"])({}, data);

  delete _customerData.id;

  if (_customerData.country) {
    _customerData.country = (0, _countries.getCode)(_customerData.country);
  }

  if (_customerData.phone) {
    _customerData.phone = _customerData.phone.replace(/[- )(]/g, '');
  }

  if (requiredFields.name && _customerData.firstName) {
    _customerData.name = {
      first: _customerData.firstName,
      last: _customerData.lastName
    };
  }

  delete _customerData.firstName;
  delete _customerData.lastName;
  if (!requiredFields.email) delete _customerData.email;
  if (!requiredFields.phone) delete _customerData.phone;

  if (requiredFields.address && _customerData.street) {
    _customerData.address = {
      street: _customerData.street,
      streetAdditional: _customerData.streetAdditional,
      zip: _customerData.zipCode,
      city: _customerData.city,
      country: _customerData.country
    };

    if (_customerData.address.streetAdditional === '') {
      delete _customerData.address.streetAdditional;
    }
  }

  delete _customerData.street;
  delete _customerData.streetAdditional;
  delete _customerData.zipCode;
  delete _customerData.city;
  delete _customerData.country;
  delete _customerData.language;
  return _customerData;
};

exports.cleanCustomerDataToBE = cleanCustomerDataToBE;

var cleanCustomerDataToFE = function cleanCustomerDataToFE() {
  var _data$name, _data$name2, _data$address, _data$address2, _data$address3, _data$address4, _data$address5;

  var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var customer = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  var _data = (0, _extends2["default"])({}, data);

  if ((_data$name = _data.name) !== null && _data$name !== void 0 && _data$name.first) {
    _data.firstName = _data.name.first;
  }

  if ((_data$name2 = _data.name) !== null && _data$name2 !== void 0 && _data$name2.last) {
    _data.lastName = _data.name.last;
  }

  if ((_data$address = _data.address) !== null && _data$address !== void 0 && _data$address.street) {
    _data.street = _data.address.street;
  }

  if ((_data$address2 = _data.address) !== null && _data$address2 !== void 0 && _data$address2.streetAdditional) {
    _data.streetAdditional = _data.address.streetAdditional;
  }

  if ((_data$address3 = _data.address) !== null && _data$address3 !== void 0 && _data$address3.zip) {
    _data.zipCode = _data.address.zip;
  }

  if ((_data$address4 = _data.address) !== null && _data$address4 !== void 0 && _data$address4.city) {
    _data.city = _data.address.city;
  }

  if ((_data$address5 = _data.address) !== null && _data$address5 !== void 0 && _data$address5.country) {
    if (!_data.language) {
      _Logger["default"].error('Language needed in order to set the country name');

      return undefined;
    }

    _data.country = (0, _countries.getName)(_data.address.country, (0, _locale.getBaseLocale)(_data.language));
  }

  if (customer !== null && customer !== void 0 && customer.nationalId) {
    _data.nationalId = customer.nationalId;
  }

  delete _data.name;
  delete _data.address;
  delete _data.language;
  return _data;
};

exports.cleanCustomerDataToFE = cleanCustomerDataToFE;